import * as Yup from "yup";

const objectIdRegex = /^[a-f\d]{24}$/i;

/**
 * Default availability object
 */
const defaultAvailability = {
    person_id: "",
    role: "",
    availability: []
};

/**
 * Slot schema
 */
const slotSchema = Yup.object().shape({
    start_time: Yup.number()
        .min(0, "Invalid start time")
        .max(1440, "Invalid start time")
        .required("Start time is required"),

    end_time: Yup.number()
        .min(0, "Invalid end time")
        .max(1440, "Invalid end time")
        .moreThan(
            Yup.ref("start_time"),
            "End time must be greater than start time"
        )
        .required("End time is required")
});

/**
 * Day availability schema
 */
const dayAvailabilitySchema = Yup.object().shape({
    day: Yup.string()
        .oneOf([
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday",
            "sunday"
        ])
        .required(),

    slots: Yup.array().of(slotSchema)
});

/**
 * Create availability schema
 */
export const availabilitySchema = Yup.object().shape({
    person_id: Yup.string()
        .matches(objectIdRegex, "Invalid Person ID")
        .required("Person is required"),

    role: Yup.string()
        .trim()
        .required("Role is required"),

    availability: Yup.array()
        .of(dayAvailabilitySchema)
        .max(7, "Availability cannot exceed 7 days")
});

/**
 * Update availability schema
 */
export const updateAvailabilitySchema = Yup.object().shape({
    person_id: Yup.string()
        .matches(objectIdRegex, "Invalid Person ID"),

    role: Yup.string().trim(),

    availability: Yup.array()
        .of(dayAvailabilitySchema)
        .max(7, "Availability cannot exceed 7 days")
});

/**
 * Schema resolver
 */
export const getValidationSchema = (modal) => {
    if (modal === "add") {
        return availabilitySchema;
    }
    if (modal === "edit") {
        return updateAvailabilitySchema;
    }
    return availabilitySchema;
};

/**
 * Initial values resolver
 */
export const getInitialValues = (modal, selectedItem) => {
    if (modal === "add") {
        return {
            ...defaultAvailability
        };
    }

    if (modal === "edit" && selectedItem) {
        return {
            person_id: selectedItem.person_id || "",
            role: selectedItem.role || "",
            availability: selectedItem.availability || []
        };
    }

    return {
        ...defaultAvailability
    };
};
